//codex-- Track the current route so loading a technician profile preserves mobile child routes.
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  //codex-- Read the latest pathname without refetching the user on every mobile navigation.
  const location = useLocation();
  const pathname = useRef(location.pathname);
  useEffect(() => { pathname.current = location.pathname; }, [location.pathname]);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/users_crud.php?getEmployee=1`,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          }
        );
        if (response.data.location === 'field') {
          setUserData(response.data);
          //codex-- Route field users into mobile mode, while keeping direct Tech Wall and other /t child links intact.
          if (pathname.current !== '/t' && !pathname.current.startsWith('/t/')) navigate('/t');
          console.warn('Tech Section');
        } else {
          setUserData(response.data);
        }
      } catch (error) {
        const isNetworkError =
          error?.code === 'ERR_NETWORK' ||
          error?.message === 'Network Error' ||
          !error?.response;

        if (isNetworkError) {
          console.error('Network error caught in UserProvider:', error);

          localStorage.removeItem('user');
          localStorage.removeItem('token');
          sessionStorage.clear();

          document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
          document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=localhost';

          toast.error('Connection lost. Redirecting to login..', {
            position: 'top-center',
          });

          navigate('/login?reason=offline');
          return;
        }

        if (error.response?.status === 401) {
          console.warn('Unauthorized - redirecting to login');

          localStorage.removeItem('user');
          localStorage.removeItem('token');
          sessionStorage.clear();

          navigate('/login?reason=unauthorized');
          return;
        }

        console.error('Other error in UserProvider:', error);
        toast.error('Error loading user data.', {
          position: 'top-center',
        });
      }
    };

    fetchUserData();
  }, [navigate]);

  return (
    <UserContext.Provider value={userData}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserData = () => useContext(UserContext);